import { render, staticRenderFns } from "./departmentList.vue?vue&type=template&id=55f956e1&scoped=true"
import script from "./departmentList.vue?vue&type=script&lang=js"
export * from "./departmentList.vue?vue&type=script&lang=js"
import style0 from "./departmentList.vue?vue&type=style&index=0&id=55f956e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f956e1",
  null
  
)

export default component.exports